
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import StageplanSidebarItem from './stageplan-sidebar-item'

class StageplanSidebarGroup extends Component {
  render() {
    const { item, itemIndex } = this.props
    const { children } = item

    return (
      <li className="stageplan-sidebar-group">
        <div className="title">{item.title}</div>

        <ul>
          {
            children.length > 0
            ? children.map((child, index) => {
                return item.id !== undefined
                ? <StageplanSidebarItem key={child.id || index}
                    item={child}
                    itemIndex={index}
                    parentItemIndex={itemIndex}
                    existingItem={child.stageplan_item}
                    fontSize={this.props.fontSize}
                    hideAnimation={this.props.hideAnimation}
                    setDragStartOffset={this.props.setDragStartOffset}
                    setRiderStageplanItemFocus={this.props.setRiderStageplanItemFocus}
                    createRiderStageplanItem={this.props.createRiderStageplanItem} />
                : null
              })
            : null
          }
        </ul>
      </li>
    )
  }
}

StageplanSidebarGroup.propTypes = {
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  fontSize: PropTypes.number,
  hideAnimation: PropTypes.bool,
  setDragStartOffset: PropTypes.func,
  setRiderStageplanItemFocus: PropTypes.func,
  createRiderStageplanItem: PropTypes.func
}

StageplanSidebarGroup.defaultProps = {
  item: {},
  itemIndex: undefined,
  fontSize: 12,
  hideAnimation: false,
  setDragStartOffset: function() {},
  setRiderStageplanItemFocus: function() {},
  createRiderStageplanItem: function() {}
}

export default StageplanSidebarGroup



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplan-sidebar-group.js